import React from 'react';
import { Box, Grid, Text, VStack } from '@chakra-ui/react';
import { SectionContainer } from '../SectionContainer';
import { ScrollReveal } from '../ScrollReveal';

const thesisPillars = [
  {
    label: 'The Problem',
    color: 'rgba(251,191,36,0.08)',
    borderColor: 'rgba(251,191,36,0.25)',
    labelColor: '#FBBF24',
    body:
      'AI deployment is capped by engineers and tied to legacy org structures. Capability scales with headcount.',
  },
  {
    label: 'The yetzira.ai Approach',
    color: 'rgba(99,102,241,0.1)',
    borderColor: 'rgba(99,102,241,0.35)',
    labelColor: '#6366F1',
    body:
      'A platform that builds its own agents — and entire organizations — and improves its own knowledge. Capability becomes a software operation.',
  },
  {
    label: 'The Opportunity',
    color: 'rgba(56,189,248,0.08)',
    borderColor: 'rgba(56,189,248,0.25)',
    labelColor: '#38BDF8',
    body:
      'A compounding, self-improving, AI-native organization-builder — defensible through accumulated knowledge, reusable agents, and a self-growth engine.',
  },
];

function ThesisCard({ pillar, index }) {
  return (
    <ScrollReveal delay={index * 0.15}>
      <Box
        bg={pillar.color}
        border="1px solid"
        borderColor={pillar.borderColor}
        borderRadius="18px"
        p={{ base: '28px', md: '36px' }}
        h="100%"
        _hover={{ transform: 'translateY(-4px)', boxShadow: '0 12px 40px rgba(0,0,0,0.3)' }}
        sx={{ transition: 'all 0.25s ease' }}
        role="article"
      >
        <Text
          fontFamily="'JetBrains Mono', monospace"
          fontWeight="500"
          fontSize="0.72rem"
          textTransform="uppercase"
          letterSpacing="1.5px"
          color={pillar.labelColor}
          mb={4}
        >
          {pillar.label}
        </Text>
        <Text fontSize="1rem" color="text.muted" lineHeight="1.7">
          {pillar.body}
        </Text>
      </Box>
    </ScrollReveal>
  );
}

export default function InvestorThesisSection() {
  return (
    <SectionContainer bg="bg.900" id="investor-thesis" aria-labelledby="thesis-heading">
      <VStack spacing={{ base: 10, md: 14 }} align="stretch">
        <ScrollReveal>
          <Text
            id="thesis-heading"
            as="h2"
            fontFamily="'Space Grotesk', sans-serif"
            fontWeight="700"
            fontSize={{ base: 'clamp(1.8rem, 5vw, 2rem)', md: 'clamp(2rem, 3.5vw, 2.75rem)' }}
            letterSpacing="-0.02em"
            color="text.primary"
            maxW="740px"
          >
            The first platform where{' '}
            <Box as="span" color="brand.400">
              capability scales faster than cost.
            </Box>
          </Text>
        </ScrollReveal>

        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
          gap={{ base: 5, md: 6 }}
        >
          {thesisPillars.map((pillar, i) => (
            <ThesisCard key={pillar.label} pillar={pillar} index={i} />
          ))}
        </Grid>
      </VStack>
    </SectionContainer>
  );
}